import React, { ReactElement } from "react";
import { connect } from "react-redux";
import { StripeProvider, Elements } from "react-stripe-elements";
import { bindActionCreators } from "redux";
import { State } from "reducers/types";
import { Dispatch } from "actions/types";
import { patchCreditCard, postCreditCard } from "./actions";
import InjectedForm from "./ModalBillingPaymentForm";
import { ModalBillingPaymentRecord } from "./services";

interface OwnProps {
  setState(): void;
}

interface PropsFromState {
  modalBillingPayment: ModalBillingPaymentRecord;
}

interface PropsFromDispatch {
  postCreditCard(modalBillingPayment: ModalBillingPaymentRecord, stripeToken: string): void;
  patchCreditCard(modalBillingPayment: ModalBillingPaymentRecord, stripeToken: string): void;
}

export type ModalBillingPaymentProps = OwnProps & PropsFromState & PropsFromDispatch;

function ModalBillingPayment(props: ModalBillingPaymentProps): ReactElement {
  return (
    <div className="ModalBillingPayment Modal__modal">
      <h5 className="Modal__title">Credit Card</h5>
      {/* StripeProvider takes in Stripe public key - it can be tracked in git */}
      <StripeProvider apiKey={window.__env.STRIPE_PUBLIC_KEY}>
        <Elements>
          <InjectedForm {...props} />
        </Elements>
      </StripeProvider>
    </div>
  );
}

function mapState(state: State): PropsFromState {
  const { modalBillingPayment } = state;

  return {
    modalBillingPayment
  };
}

function mapDispatch(dispatch: Dispatch): PropsFromDispatch {
  return bindActionCreators({ patchCreditCard, postCreditCard }, dispatch);
}

const Connector = connect(
  mapState,
  mapDispatch
)(ModalBillingPayment);

export default Connector;
export { ModalBillingPayment };
